<template>
  <v-layout row wrap>
    <v-flex xs4>
      <v-text-field label="ID" v-model="editedItem.id" readonly></v-text-field>
    </v-flex>
    <v-flex xs8>
      <v-text-field label="Full Name" v-model="editedItem.dealerName"></v-text-field>
    </v-flex>

    <v-flex xs12>
      <ValidationProvider v-slot="{ errors }" name="Email" rules="email|required">
        <v-text-field
          label="Email"
          v-model="editedItem.email"
          data-vv-as="Email"
          name="item_email"
          data-vv-validate-on="change"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-flex>
    <v-flex xs12>
      <v-text-field label="Business" v-model="editedItem.currentBusiness"></v-text-field>
    </v-flex>

    <v-flex xs4>
      <v-text-field name="postcode" label="Post Code" v-model="editedItem.postcode" mask="####"></v-text-field>
    </v-flex>
    <v-flex>
      <v-text-field label="Mobile" v-model="editedItem.mobileNo" mask="#### ### ###"></v-text-field>
    </v-flex>
    <v-select
      xs4
      :items="['New','Open']"
      v-model="editedItem.relationShipStatus"
      label="Relationship Status"
    ></v-select>
  </v-layout>
</template>

<script>
export default {
  name: "DealerDetails",
  props: ["editedItem"]
};
</script>

<style scoped>
</style>